export const TKeyCompany = {
  COMPANIES: "COMPANIES",
  COMPANY_ADMIN_BRANDING: "COMPANY_ADMIN_BRANDING",
  COMPANY_ADD: "COMPANY_ADD",
  COMPANY_EDIT: "COMPANY_EDIT",
  COMPANY_NAME: "COMPANY_NAME",
  COMPANY_COLOR: "COMPANY_COLOR",
  COMPANY_COLOR_RESET: "COMPANY_COLOR_RESET",
  COMPANY_LOGO: "COMPANY_LOGO",
  COMPANY_SLUG: "COMPANY_SLUG",
  COMPANY_SLUG_PLACEHOLDER: "COMPANY_SLUG_PLACEHOLDER",
  COMPANY_SLUG_TAKEN: "COMPANY_SLUG_TAKEN",
  COMPANY_SLUG_CONTACT: "COMPANY_SLUG_CONTACT",
  COMPANY_DOMAIN_FAILED: "COMPANY_DOMAIN_FAILED",
  COMPANY_DELETE_TITLE: "COMPANY_DELETE_TITLE",
  COMPANY_DELETE_WARNING: "COMPANY_DELETE_WARNING",
  COMPANY_DELETE_CONFIRM: "COMPANY_DELETE_CONFIRM",
  COMPANY_MEMBER_REMOVE_TITLE: "COMPANY_MEMBER_REMOVE_TITLE",
  COMPANY_MEMBER_REMOVE_TEXT: "COMPANY_MEMBER_REMOVE_TEXT",
  COMPANY_MEMBER_REMOVE_CONFIRM: "COMPANY_MEMBER_REMOVE_CONFIRM",
  COMPANY_LEAVE: "COMPANY_LEAVE",
  COMPANY_LEAVE_TITLE: "COMPANY_LEAVE_TITLE",
  COMPANY_LEAVE_TEXT: "COMPANY_LEAVE_TEXT",
  COMPANY_LEAVE_CONFIRM: "COMPANY_LEAVE_CONFIRM",
  COMPANY_MEMBER_ACCESS_EDITOR: "COMPANY_MEMBER_ACCESS_EDITOR",
  COMPANY_MEMBER_ACCESS_EDITOR_HINT: "COMPANY_MEMBER_ACCESS_EDITOR_HINT",
  COMPANY_MEMBER_ACCESS_READER_HINT: "COMPANY_MEMBER_ACCESS_READER_HINT",
  COMPANY_CREDITS_CAP: "COMPANY_CREDITS_CAP",
  COMPANY_CREDITS_LIMIT: "COMPANY_CREDITS_LIMIT",
  COMPANY_MEMBERS_COUNT: "COMPANY_MEMBERS_COUNT",
  COMPANY_LIST_EMPTY: "COMPANY_LIST_EMPTY",
  COMPANY_MEMBERS: "COMPANY_MEMBERS",
  COMPANY_MEMBERS_EMPTY: "COMPANY_MEMBERS_EMPTY",
  COMPANY_MEMBER_EMAIL: "COMPANY_MEMBER_EMAIL",
  COMPANY_MEMBER_ROLE: "COMPANY_MEMBER_ROLE",
  COMPANY_MEMBER_ROLE_ADMIN_DESC: "COMPANY_MEMBER_ROLE_ADMIN_DESC",
  COMPANY_MEMBER_ROLE_MEMBER_DESC: "COMPANY_MEMBER_ROLE_MEMBER_DESC",
  COMPANY_MEMBER_ADD: "COMPANY_MEMBER_ADD",
  COMPANY_MEMBER_EDIT: "COMPANY_MEMBER_EDIT",
  COMPANY_MEMBER_ADD_TITLE: "COMPANY_MEMBER_ADD_TITLE",
  COMPANY_MEMBER_EDIT_TITLE: "COMPANY_MEMBER_EDIT_TITLE",
  COMPANY_MEMBER_NOT_FOUND: "COMPANY_MEMBER_NOT_FOUND",
  COMPANY_MEMBER_INVITED: "COMPANY_MEMBER_INVITED",
  COMPANY_MEMBER_LIMIT: "COMPANY_MEMBER_LIMIT",
  COMPANY_MEMBER_LAST_OWNER: "COMPANY_MEMBER_LAST_OWNER",
  COMPANY_ROLE_OWNER: "COMPANY_ROLE_OWNER",
  COMPANY_ROLE_ADMIN: "COMPANY_ROLE_ADMIN",
  COMPANY_ROLE_MEMBER: "COMPANY_ROLE_MEMBER",
} as const;
